import styles from "./NumberAndData.module.css";

const NumberAndData = ({
  number,
  label,
  backgroundVar = "--Primary_Color",
}) => {
  const styleVars = {
    "--custom-color": backgroundVar,
  };

  return (
    <div className={styles.wrapper} style={styleVars}>
      <span className={styles.number}>{number}</span>
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default NumberAndData;
